import PATHS from "routes/path";
import { AuthorizeParams } from "services/authorizeService";

export const redirectLogin = async () => {
    try {
        const mode = import.meta.env.VITE_LOGIN_MODE;
        const query = new URLSearchParams(window.location.search);
        const authorizeParams: AuthorizeParams | undefined = query.get("client_id")
          ? {
              client_id: query.get("client_id") || "",
              redirect_uri: query.get("redirect_uri") || "",
              response_type: query.get("response_type") || "",
              scope: query.get("scope") || "",
              state: query.get("state") || "",
            }
          : undefined;
        
        if (mode === "SSO") {
          const providerId = import.meta.env.VITE_LOGIN_SSO_PROVIDER_ID;
          if (authorizeParams) {
            sessionStorage.setItem("authorize_params", JSON.stringify(authorizeParams));
          }
          sessionStorage.setItem("provider", `${providerId}`);
          window.location.replace(`${import.meta.env.VITE_APP_ENDPOINT_API}/sso-service/api/sso/login?provider=${providerId}`)
        } else {
            const currentPath = window.location.pathname;
            if (currentPath !== PATHS.LOGIN) {


              const url = new URL(PATHS.LOGIN, window.location.origin);
              if (authorizeParams) {
                Object.entries(authorizeParams).forEach(([key, value]) => {
                  url.searchParams.set(key, value);
                });
              }
              window.location.replace(url.toString());
            }
        }
    } catch {
        const url = new URL(PATHS.LOGIN, window.location.origin);
        window.location.replace(url.toString());
    }
};
